import { HttpClient, HttpContext, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { DadataOrganization } from '../interfaces/dadata/IDadataOrganization';
import { AUTHORIZATION_TYPE } from "../tokens/context.tokens";
import { Observable } from "rxjs";
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DadataService {
  private headers: HttpHeaders;
  private context: HttpContext;
  private apiUrl = environment.dadataApiUrl;
  private suggestUrl = '/suggest/party';
  private findByIdUrl = '/findByUd/party';

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders()
      .set('authorization', `Token ${environment.dadataToken}`)
      .set('Accept', `application/json`)
      .set('Content-Type', 'application/json');
    this.context = new HttpContext().set(AUTHORIZATION_TYPE, 'none');
  }

  async getSuggest(body: { query: string; type?: string }) {
    const opt = {
      headers: this.headers,
      context: this.context,
    };
    return await this.http
      .post<{ suggestions: DadataOrganization[] }>(
        this.apiUrl + this.suggestUrl,
        body,
        opt
      )
      .toPromise();
  }

  getIpData(ip?: string): Observable<{ country_iso_code: string, city: string }> {
    if (ip) {
      return this.http
        .post(
          this.apiUrl + '/iplocate/address',
          { ip: ip },
          { headers: this.headers, context: this.context }
        )
        .pipe(
          take(1),
          map((data: any) => data.location?.data)
        );
    } else {
      return this.http
        .get(this.apiUrl + '/iplocate/address', {
          headers: this.headers,
          context: this.context,
        })
        .pipe(
          take(1),
          map((data: any) => data.location?.data)
        );
    }
  }
}
